/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_EditInputs */

const vi_grower_edit = /** @type {(inputs: Grower_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa hộ trồng`)
};

/**

* @param {Grower_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_edit = /** @type {((inputs?: Grower_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_edit(inputs)
});